// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.grid img[data-v-18f280b5] {\n\n    margin: auto;\n\n    width: 5rem;\n\n    padding-bottom: 0.75rem\n}\n.grid div[data-v-18f280b5] {\n\n    text-align: center;\n\n    font-size: 1.125rem;\n\n    line-height: 1.75rem;\n\n    font-weight: 800;\n\n    --tw-text-opacity: 1;\n\n    color: rgb(68 64 60 / var(--tw-text-opacity))\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
